import React, { useEffect, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import { FiMenu } from "react-icons/fi";
import { Loader } from "../../../../components/Loader/Loader";
import MaintananceTable from "../../../../components/Tables/MaintenanceTable";
import MaintenanceDropDwonFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import {
  StoreFilters,
  StoreStockAnalysis,
  StoreStockAnalysisFun,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import { useTheme } from "../../../../Themecontext/Themecontext";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";
import Calendar from "react-calendar";

const financialYearMonths = [
  { name: "April", id: "04" },
  { name: "May", id: "05" },
  { name: "June", id: "06" },
  { name: "July", id: "07" },
  { name: "August", id: "08" },
  { name: "September", id: "09" },
  { name: "October", id: "10" },
  { name: "November", id: "11" },
  { name: "December", id: "12" },
  { name: "January", id: "01" },
  { name: "February", id: "02" },
  { name: "March", id: "03" },
];

export const StaockAnalysis = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, StoreStockAnalysisdata } = useSelector(
    (state) => state.MaintenanceSlice,
  );
  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  const Firm = Cookies.get("Firm");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState([]);

  const [selectedmonth, setSelectedmonth] = useState("");
  const [selectedmonthId, setSelectedmonthId] = useState([]);

  const [selectedItemGroup, setSelectedItemGroup] = useState("");
  const [selectedItemGroupId, setSelectedItemGroupId] = useState([]);

  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;

    return `${year}${monthValue}`; // ex: 202404
  };

  useEffect(() => {
    dispatch(StoreFilters());

    dispatch(
      StoreStockAnalysis({
        firm: Firm,
        IdxMonthNameIDs:
          filter.month && filter.month.length > 0
            ? filter.month
              .map((m) => getMonthId(String(m).padStart(2, "0")))
              .join(",")
            : getMonthId("04"),
      }),
    );
  }, [Firm, dispatch]);

  const [filter, setFilter] = useState({
    itemName: [],
    month: [],
    itemGroup: [],
  });

  const [search, setSearch] = useState({
    itemName: "",
    month: "",
    itemGroup: "",
  });

  const itemNameList =
    StoreFiltersdata?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  const itemGroupList =
    StoreFiltersdata?.ItemGroup?.map((item) => ({
      label: item.ItemGroupName,
      value: item.ItemGroupID,
    })) || [];

  const monthList =
    financialYearMonths?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);



  const handleSubmit1 = () => {
    dispatch(StoreStockAnalysisFun());

    dispatch(
      StoreStockAnalysis({
        firm: Firm,
        ItemIDs: selectedProductionId.join(","),
        ItemGrpIDs: selectedItemGroupId.join(","),
        IdxMonthNameIDs: selectedmonthId
          ? getMonthId(String(selectedmonthId).padStart(2, "0"))
          : getMonthId("04"),
      })
    );
  };


  const handleSubmit = () => {
    dispatch(StoreStockAnalysisFun());

    dispatch(
      StoreStockAnalysis({
        firm: Firm,
        ItemIDs: filter.itemName.join(","),
        ItemGrpIDs: filter.itemGroup.join(","),
        IdxMonthNameIDs:
          filter.month?.length > 0
            ? filter.month
              .map((m) => getMonthId(String(m).padStart(2, "0")))
              .join(",")
            : getMonthId("04"),
      })
    );

    setShowFilter(false);
  };

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      if (type === "month") {
        return {
          ...prev,
          [type]: selected.includes(item.value) ? [] : [item.value],
        };
      }

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const columns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "itemname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },

    {
      label: "Unit",
      key: "UnitName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },

    { label: "Opening Qty", key: "Opening", align: "right", format: true },
    {
      label: "Opening Amt",
      key: "OpeningAmt",
      align: "right",
      format: true,
    },

    { label: "Inward Qty", key: "Inward", align: "right", format: true },
    {
      label: "Inward Amt",
      key: "InwardAmt",
      align: "right",
      format: true,
    },

    { label: "Issue Qty", key: "Outward", align: "right", format: true },
    {
      label: "Issue Amt",
      key: "OutwardAmt",
      align: "right",
      format: true,
    },

    {
      label: "Issue Return Amt",
      key: "OutwardRetAmt",
      align: "right",
      format: true,
    },

    { label: "Closing Qty", key: "Closing", align: "right", format: true },
    {
      label: "Closing Amt",
      key: "ClosingAmt",
      align: "right",
      format: true,
    },

    { label: "Rate", key: "itemRate1", align: "right", format: true },

    {
      label: "Physical Amt",
      key: "PhysicalAmt",
      align: "right",
      format: true,
    },
    {
      label: "Shortage Amt",
      key: "ShortageAmt",
      align: "right",
      format: true,
    },
  ];

  const initialData = (StoreStockAnalysisdata?.Data || []).map((row) => ({
    itemname: row.itemname,
    UnitName: row.UnitName,
    Opening: row.Opening,
    Inward: row.Inward,
    Outward: row.Outward,
    Closing: row.Closing,
    itemRate1: row.itemRate1,
    ClosingAmt: row.ClosingAmt,
    InwardAmt: row.InwardAmt,
    OpeningAmt: row.OpeningAmt,
    OutwardAmt: row.OutwardAmt,
    OutwardRetAmt: row.OutwardRetAmt,
    PhysicalAmt: row.PhysicalAmt,
    ShortageAmt: row.ShortageAmt,
  }));

  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!StoreStockAnalysisdata || StoreStockAnalysisdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header closeButton>
          {" "}
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <MaintenanceFilterBox
              title="Item Name"
              items={itemNameList}
              search={search.itemName}
              setSearch={(val) => handleSearch("itemName", val)}
              selectedItems={filter.itemName}
              toggleItem={(item) => toggleItem("itemName", item)}
              selectAll={() => selectAll("itemName", itemNameList)}
            />

            <MaintenanceFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filter.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            <MaintenanceFilterBox
              title="Item Group"
              items={itemGroupList}
              search={search.itemGroup}
              setSearch={(val) => handleSearch("itemGroup", val)}
              selectedItems={filter.itemGroup}
              toggleItem={(item) => toggleItem("itemGroup", item)}
              selectAll={() => selectAll("itemGroup", itemGroupList)}
            />

            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "44px",
                padding:"12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="g-2 align-items-end ">
          {/* DATE */}
          <Col xl={3} lg={6}>
            <MaintenanceDropDwonFilterBox
              label="Production Group"
              data={itemNameList}
              selectedValue={selectedProduction}
              setSelectedValue={setSelectedProduction}
              selectedId={selectedProductionId}
              setSelectedId={setSelectedProductionId}
              placeholder="Select Production"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          <Col xl={3} lg={6}>
            <MaintenanceDropDwonFilterBox
              label="Month Name"
              data={monthList}
              selectedValue={selectedmonth}
              setSelectedValue={setSelectedmonth}
              selectedId={selectedmonthId}
              setSelectedId={setSelectedmonthId}
              placeholder="Select Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
              isMulti={false}
            />
          </Col>
          <Col xl={3} lg={6}>
            <MaintenanceDropDwonFilterBox
              label="Item Group"
              data={itemGroupList}
              selectedValue={selectedItemGroup}
              setSelectedValue={setSelectedItemGroup}
              selectedId={selectedItemGroupId}
              setSelectedId={setSelectedItemGroupId}
              placeholder="Select Item Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* BUTTON */}
          <Col xl={3} lg={6}>
            <button
              onClick={handleSubmit1}
              style={{
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          STOCK ANALYSIS
        </div>

        <MaintananceTable columns={columns} data={initialData} />
      </div>

      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MaintenanceCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaockAnalysis;
